module.exports = __webpack_public_path__ + "img/classic_rental40_3.40d5e752.jpg";